import { Route, Routes } from 'react-router-dom';
import PageBranch from '../pages/branch';
import PageDepartment from '../pages/department';
import PageOrganization from '../pages/organization';
import PageUnit from '../pages/unit';
import PrivateRoute from './private-route';
import PageAdmin from '../pages/admin';
import PageAuth from '../pages/auth';
import PageUnauthorized from '../pages/unauthorized';
import PageNotFound from '../pages/not-found';
import PageHelpDesk from '../pages/helpDesk';
import PageCybersecurity from '../pages/cybersecurity';
import Reports from '../pages/reports';
import Models from '../pages/models';
import Uploads from '../pages/uploads';
import PageIncidents from '../pages/incidents';
import CreateIncident from '../pages/incidents/create';
import IncidentDetails from '../pages/incidents/details';
import EditIncident from '../pages/incidents/edit';
import PageUsers from '../pages/users';
import PageOrganizations from '../pages/organizations';

const AppRoutes = () => (
  <Routes>
    <Route path='/acessar' element={<PageAuth />} />

    <Route
      path='/'
      element={
        <PrivateRoute>
          <PageAdmin />
        </PrivateRoute>
      }
    />

    <Route
      path='/prefeitura/:orgId/'
      element={
        <PrivateRoute>
          <PageOrganization />
        </PrivateRoute>
      }
    />

    <Route
      path='/prefeitura/secretaria/:branchId/'
      element={
        <PrivateRoute>
          <PageBranch />
        </PrivateRoute>
      }
    />

    <Route
      path='/prefeitura/secretaria/unidade/:unitId'
      element={
        <PrivateRoute>
          <PageUnit />
        </PrivateRoute>
      }
    />
    <Route
      path='/prefeitura/secretaria/unidade/departamento/:departmentId'
      element={
        <PrivateRoute>
          <PageDepartment />
        </PrivateRoute>
      }
    />

    <Route
      path='/reports'
      element={
        <PrivateRoute>
          <Reports />
        </PrivateRoute>
      }
    />

    <Route
      path='/models'
      element={
        <PrivateRoute>
          <Models />
        </PrivateRoute>
      }
    />

    <Route
      path='/library'
      element={
        <PrivateRoute>
          <Uploads />
        </PrivateRoute>
      }
    />

    <Route
      path='/service-desk'
      element={
        <PrivateRoute>
          <PageHelpDesk />
        </PrivateRoute>
      }
    />

    <Route
      path='/usuarios'
      element={
        <PrivateRoute>
          <PageUsers />
        </PrivateRoute>
      }
    />

    <Route
      path='/organizacoes'
      element={
        <PrivateRoute>
          <PageOrganizations />
        </PrivateRoute>
      }
    />

    <Route
      path='/prefeitura/:orgId/usuarios'
      element={
        <PrivateRoute>
          <PageUsers />
        </PrivateRoute>
      }
    />

    <Route
      path='/prefeitura/secretaria/:branchId/usuarios'
      element={
        <PrivateRoute>
          <PageUsers />
        </PrivateRoute>
      }
    />

    <Route
      path='/prefeitura/secretaria/unidade/:unitId/usuarios'
      element={
        <PrivateRoute>
          <PageUsers />
        </PrivateRoute>
      }
    />

    <Route
      path='/prefeitura/secretaria/unidade/departamento/:departmentId/usuarios'
      element={
        <PrivateRoute>
          <PageUsers />
        </PrivateRoute>
      }
    />

    <Route
      path='/cybersecurity'
      element={
        <PrivateRoute>
          <PageCybersecurity />
        </PrivateRoute>
      }
    />

    <Route
      path='/prefeitura/:orgId/incidents'
      element={
        <PrivateRoute>
          <PageIncidents />
        </PrivateRoute>
      }
    />

    <Route
      path='/prefeitura/:orgId/incidents/create'
      element={
        <PrivateRoute>
          <CreateIncident />
        </PrivateRoute>
      }
    />

    <Route
      path='/prefeitura/:orgId/incidents/:id'
      element={
        <PrivateRoute>
          <IncidentDetails />
        </PrivateRoute>
      }
    />

    <Route
      path='/prefeitura/:orgId/incidents/:id/edit'
      element={
        <PrivateRoute>
          <EditIncident />
        </PrivateRoute>
      }
    />

    {/* Rotas de incidentes para nível de secretaria */}
    <Route
      path='/prefeitura/secretaria/:branchId/incidents'
      element={
        <PrivateRoute>
          <PageIncidents />
        </PrivateRoute>
      }
    />

    <Route
      path='/prefeitura/secretaria/:branchId/incidents/create'
      element={
        <PrivateRoute>
          <CreateIncident />
        </PrivateRoute>
      }
    />

    <Route
      path='/prefeitura/secretaria/:branchId/incidents/:id'
      element={
        <PrivateRoute>
          <IncidentDetails />
        </PrivateRoute>
      }
    />

    <Route
      path='/prefeitura/secretaria/:branchId/incidents/:id/edit'
      element={
        <PrivateRoute>
          <EditIncident />
        </PrivateRoute>
      }
    />

    {/* Rotas de incidentes para nível de unidade */}
    <Route
      path='/prefeitura/secretaria/unidade/:unitId/incidents'
      element={
        <PrivateRoute>
          <PageIncidents />
        </PrivateRoute>
      }
    />

    <Route
      path='/prefeitura/secretaria/unidade/:unitId/incidents/create'
      element={
        <PrivateRoute>
          <CreateIncident />
        </PrivateRoute>
      }
    />

    <Route
      path='/prefeitura/secretaria/unidade/:unitId/incidents/:id'
      element={
        <PrivateRoute>
          <IncidentDetails />
        </PrivateRoute>
      }
    />

    <Route
      path='/prefeitura/secretaria/unidade/:unitId/incidents/:id/edit'
      element={
        <PrivateRoute>
          <EditIncident />
        </PrivateRoute>
      }
    />

    {/* Rotas de incidentes para nível de departamento */}
    <Route
      path='/prefeitura/secretaria/unidade/departamento/:departmentId/incidents'
      element={
        <PrivateRoute>
          <PageIncidents />
        </PrivateRoute>
      }
    />

    <Route
      path='/prefeitura/secretaria/unidade/departamento/:departmentId/incidents/create'
      element={
        <PrivateRoute>
          <CreateIncident />
        </PrivateRoute>
      }
    />

    <Route
      path='/prefeitura/secretaria/unidade/departamento/:departmentId/incidents/:id'
      element={
        <PrivateRoute>
          <IncidentDetails />
        </PrivateRoute>
      }
    />

    <Route
      path='/prefeitura/secretaria/unidade/departamento/:departmentId/incidents/:id/edit'
      element={
        <PrivateRoute>
          <EditIncident />
        </PrivateRoute>
      }
    />

    <Route
      path='/sem-permissao'
      element={
        <PrivateRoute>
          <PageUnauthorized />
        </PrivateRoute>
      }
    />

    <Route path='*' element={<PageNotFound />} />
  </Routes>
);

export default AppRoutes;
